import { z } from 'zod'

export const promptSchema = z.object({
  prompt: z.string().trim().nonempty(),
  usecaseId: z.string(),
  organizationId: z.string(),
  teamId: z.string(),
  assets: z.array(
    z.object({
      name: z.string(),
      url: z.string(),
      type: z.string(),
      key: z.string(),
    })
  ),
})

export const extraPromptFeaturesSchema = z.object({
  researchEnabled: z.boolean().default(false),
  expandFrontendPrototype: z.boolean().default(false),
})

export type PromptData = z.infer<typeof promptSchema>
export type ExtraPromptFeatures = z.infer<typeof extraPromptFeaturesSchema>
